<template lang="pug">
div.bs4.trust-pilot-review(:data-review-count="(data && data.total_reviews) || 0")
  div.trustpilot-main-widget.container.px-0.d-customize-none.modal-background(v-if="data !== null")
    .title.Heading.u-h3.Black {{ __('Customer Reviews') }}
    .avgStars {{ data.average_score }}
      div.star_image
        template(v-for="n in 5")
          img(v-if="n > data.average_score", :src="CDNPath('/img/trustpilot/star.svg')")
          img(v-else, :src="CDNPath('/img/trustpilot/star_filled.svg')")
      p {{ __('Based on') }} {{ data.total_reviews }} {{ __('reviews') }}
    .review_detail
      .filter_by_rating
        p(style='font-weight:bold;order:100') {{ __('Filter by Rating') }}
        b.stars_summary(v-for="n in 5", :style="{order : index}")
          span(style='width:45px', @click="star=n") {{ n }} {{ __('Star') }}
          .progress_bar(@click="star=n")
            .progress(v-if="data.stars_reviews[n]", :style="{ width: (data.stars_reviews[n])*100/data.total_reviews +'%' }")
            .progress(v-else,:style="{ width: '0%' }")
          span.count(@click="star=n") ({{ data.stars_reviews[n] || 0 }})
      .filter_by_attribute
        .level
          b {{ __('Material') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Materials') && n <= data.attributes.Materials ) }")
        .level
          b {{ __('Design') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Design') && n <= data.attributes.Design )  }")
        .level
          b {{ __('Quality') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Quality') && n <= data.attributes.Quality )  }")
        .level
          b {{ __('Durability') }}
          div(v-for="n in 5", :class="{ first : n == 1, last : n == 5, fill : ( containsKey(data.attributes,'Durability') && n <= data.attributes.Durability )  }")
    div.reviews
      hr
      div.options
        div.lang(@click="show.languages = 1",v-click-outside="hideLanguage") {{ __('Language') }}
          img(class='options_arrow', :src="CDNPath('/img/trustpilot/chevron_down.svg')")
          div.option_list(v-if='show.languages')
            div(v-for='(lang,label) in languages',:value='label',@click="language = label", :class="{ selected : language == label }") {{ lang }} ({{ data.language_reviews[label] || 0 }})
        div.sort_by(@click="show.sorting = 1",v-click-outside="hideSorting")
          span {{ __('Sort By:') }} {{ __(sortings[sorting]) }}
          img(class='options_arrow', :src="CDNPath('/img/trustpilot/chevron_down.svg')")
          div.option_list(v-if='show.sorting')
            div(v-for='(sort,label) in sortings',:value='label',@click="sorting = label", :class="{ selected : sorting == label }") {{ __(sort) }}
      hr
      div.filter_row(v-if="language != '' || star != ''")
        p.filter_label {{ __('Active Filters:') }}
        div.active_filters(v-if="language != ''", v-on:click="language = ''") {{ languages[language] }}
        div.active_filters(v-if="star != ''", v-on:click="star = ''") {{ star }} Star
        div.clear_filter(v-on:click="language = ''; star = ''") {{ __('Clear All') }}

      template(v-if="data.reviews.length")
        template(v-for="review in data.reviews")
          .review
            .sidebar
              .customer_name {{ review.consumer_name }}
              .review_date {{ moment(review.createdAt).format('MM/DD/YY') }}
              .product_name {{ data.skus[review.sku] || data.skus[review.related_sku] }}
            .review_detail_content
              template(v-for="n in 5")
                img.star_image(v-if="n > review.stars", :src="CDNPath('/img/trustpilot/star.svg')")
                img.star_image(v-else, :src="CDNPath('/img/trustpilot/star_filled.svg')")
              .review_content {{ review.content }}
              //- .review_attachments(v-for="attachment in review.attachments")
              //-   template(v-for="file in attachment.processedFiles")
              //-     img(:src="file.url")
              //- .review_attachments(v-if="review.has_image === '1'")
              //-   img(:src="'/img/yotpo/square/'+review.external_id+'.png'")
              vue-preview.review_attachments(:slides="review.images")
          hr
        div.pagination
          img(:src="CDNPath('/img/trustpilot/prev.png')", @click="page > 1 ? page = page-1 : false")
          div.page(v-for="n in data.total_pages", :class="{ show: ( data.page - 2 <= n && n <= data.page + 2 ) || (data.page <= 3 && n <= 5 ) || (data.page > data.total_pages - 3 && n > data.total_pages - 5 ), active : n == data.page }", @click="page = n") {{ n }}
          img(:src="CDNPath('/img/trustpilot/next.png')", @click="page < data.total_pages ? page = page+1 : false")
      div.no-review(v-else) {{ __('No Review') }}
  div(v-else) {{ __('Loading') }}

</template>
<script>
import ClickOutside from 'vue-click-outside'
import VuePreview from 'vue-preview'

export default {

  components : {
  },

  props : ['sku', 'CDNPath'],

  name: 'trust-pilot',

  data() {
    return {
      data : null,
      language : '',
      sorting : 'photos',
      page : 1,
      star : '',
      languages: {
        'en' : 'English',
        'ko' : 'Korean',
        'ja' : 'Japanese',
        'zh-CN' : 'Chinese',
        'es' : 'Spanish'
      },
      sortings: {
        'newest' : 'Newest',
        'high' : 'Rating: High to Low',
        'photos' : 'With Photos'
      },

      show: {
        languages: 0,
        sorting: 0,
      },

      // Generic properties
      eventHub : window.vueEventHub,

      injectedMarkup : false,
    }
  },

  computed : {


  },

  watch : {
    language: function(val){
      this.page = 1;
      this.getReviews();
      this.hideLanguage();
    },
    page: function(val){
      this.getReviews();
    },
    sorting: function(val){
      this.page = 1;
      this.getReviews();
      this.hideSorting();
    },
    star: function(val){
      this.page = 1;
      this.getReviews();
    },
  },

  beforeMount() {
    this.__ = this.__ || window.__
  },

  async created() {
    this.getReviews();


  },

  methods : {
    getReviews(callback){
      fetch(`//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/private/5m/Review?fn=getTrustPilotReviews&sku=`+this.sku+`&language=`+this.language+`&sorting=`+this.sorting+`&page=`+this.page+`&star=`+this.star, {
        method : 'GET',
        credentials : 'same-origin'
      })
      .then(res => res.json())
      .then(result => {
        this.data = result.data
        callback && callback(this.data)
      })
    },
    containsKey(obj, key ) {
        return Object.keys(obj).includes(key);
    },
    hideLanguage(){
      this.show.languages = 0;
    },
    hideSorting(){
      this.show.sorting = 0;
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss">
.trust-pilot-review .trustpilot-main-widget {
  padding-top: 90px;
  padding-bottom:60px;
  color:black;

  .title {
    font-size: 40px;
    line-height: 40px;
    color: #2d2d2d;
    text-align: center;
    font-family: pangram,Helvetica,Arial,sans-serif;
  }
  .avgStars {
    text-align: center;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
    font-size: 50px;
    line-height: 50px;
    font-family: pangram;
    margin-top: 45px;
    max-width: 100%;

    .star_image {
      margin-left: auto;
      margin-right: auto;

      img{
        height: 30px;
        display: inline-block;
        margin-left: 2px;
        margin-right: 2px;
      }
    }
    p {
      font-size: 12px !important;
      color: #888 !important;
      margin-top: 8px !important;
    }
  }
  .review_detail {
    display: flex;
    width: 85%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;

    .filter_by_rating {
      flex: 1;
      margin-right: 35px;
      display:flex;
      flex-direction:column-reverse;
      justify-content: flex-end;

      .stars_summary {
        cursor: pointer;
        display: flex;
        margin-top: 18px;
        .progress_bar {
          flex: 1;
          background-color: #EAEAEA;
          margin-left: 20px;
          margin-right: 20px;
          position:relative;
          .progress {
            position: absolute;
            background-color: #2C5DAB;
            height: 100%;
            border-radius:0px!important;
          }
        }
      }
      .count {
        color: #888888;
        width: 30px;
      }
    }
    .filter_by_attribute {
      flex: 1;
      margin-left: 35px;
      padding-top: 36px;

      .level {
        display: flex;
        margin-bottom: 18px;
        height: 22px;

        b {
          width: 130px;
        }
        // .first {
        //   &::after {
        //     content: "Poor";
        //     display: block;
        //     color: #888888;
        //     font-size: 12px;
        //     top: 100%;
        //     position: absolute;
        //   }
        // }
        // .last {
        //   &::after {
        //     content: "Great";
        //     display: block;
        //     color: #888888;
        //     font-size: 12px;
        //     top: 100%;
        //     position: absolute;
        //     right: 0;
        //   }
        // }
        div {
          flex: 1;
          background-color: #EAEAEA;
          margin-left: 1px;
          margin-right: 1px;
          height: 22px;
          position: relative;
        }
        div.fill {
          background-color: #2C5DAB;
        }
      }
    }
  }
  .reviews{
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .options{
      display: flex;
      font-family: "HelveticaNeue", Helvetica, Arial, sans-serif;
      font-size: 17px;
      font-weight: bold;
      cursor: pointer;

      .options_arrow{
        height: 10px;
        margin-left: 10px;
      }

      .option_list{
        border: 1px solid #B7B7B7;
        padding:8px;
        position: absolute;
        background-color: white;
        top: 105%;
        z-index: 1;

        div{
          height:34px;
          line-height:34px;
          padding-left:10px;
          padding-right:10px;

          &:hover{
            background-color:black!important;
            color: white;
          }

          &.selected{
            background-color:#EAEAEA;
          }
        }
      }

      .lang{
        flex:1;
        position: relative;
      }
      .sort_by{
        flex:2;
        justify-content: right;
        text-align: right;
        position: relative;

        .option_list{
          right: 0;
        }
      }
    }
    .filter_row{
      margin-bottom:40px;

      .filter_label{
        color: #B7B7B7!important;
        font-size: 15px!important;
        display: inline-block;
        margin-right:15px;
      }
      .active_filters{
        display: inline-block;
        border: 1px solid black;
        padding: 5px 8px;
        margin-right:5px;

        &::after {
          content: "✖";
          margin-left: 20px;
          cursor: pointer;
        }
      }
      .clear_filter{
        display: inline-block;
        text-decoration: underline;
        font-weight: bold;
        margin-left: 10px;
        cursor:pointer;
      }
    }
    .review{
      display: flex;
      min-height: 150px;

      .sidebar{
        flex:1;
        display:flex;
        flex-direction:column;
        margin-right:50px;

        .customer_name{
          font-weight:bold
        }

        .review_date{
          flex:1;
          font-family: "HelveticaNeue", Helvetica, Arial, sans-serif;
        }

        .product_name{
          font-weight:bold;
        }
      }
      .review_content{
        margin-top:8px;
        margin-bottom:25px;
      }
      .review_detail_content{
        flex:4;

        .star_image{
          margin-left: 2px;
          margin-right: 2px;
        }
      }
      .review_attachments{

        .my-gallery{
          display:flex;
          flex-wrap: wrap;

          img{
            width:100px;
            margin: 5px;
          }
        }
      }
    }
  }
  .no-review{
    text-align:center;
    margin-bottom: 50px;
  }
  .pagination{
    display: flex!important;
    width: 300px;
    margin-left: auto!important;
    margin-right: auto!important;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-top: 35px;

    img{
      cursor:pointer;
    }

    .page{
      color:#B7B7B7;
      font-size: 18px;
      cursor:pointer;
      margin-left:5px;
      margin-right:5px;
      display:none;

      &.show{
        display:block;
      }

      &.active{
        color:black;
      }
    }
  }
}

@media (max-width: 767px) {
  .trust-pilot-review .trustpilot-main-widget {
    padding-top: 60px;

    .review_detail{
      display:block;

      .filter_by_rating,.filter_by_attribute{
        margin: 0px;
        .level {
          padding-bottom: 10px;
        }
      }
    }

    .reviews{
      .options{
        display: block;

        .sort_by{
          text-align:left;
          margin-top: 15px;

          .option_list{
            right: unset;
          }
        }
      }

      .review{
        flex-direction: column;

        .sidebar{
          .review_date{
            flex:unset;
          }

          .product_name{
            margin-bottom: 16px;
          }
        }
      }
    }
  }
}

// Force remove share and full screen button
.pswp__button.pswp__button--share,
.pswp__button.pswp__button--fs{
  display:none!important;
}
</style>



// WEBPACK FOOTER //
// CMSTrustPilot.vue?e2334d3e